import {
  GET_TYPE_ASN_DOCUMENT_EXITO,
  GET_TYPE_ASN_DOCUMENT
} from '../types/typeAsnDocumentActionsTypes'
import { TypeAsnDocument } from '../../interfaces/Asn/TypeAsnDocument'

export type TypeAsnDocumentAction =
  | TypeAsnDocumentsAction
  | TypeAsnDocumentsActionAsync

// Esto va a REDUX
export interface TypeAsnDocumentsAction {
  type: typeof GET_TYPE_ASN_DOCUMENT_EXITO
  typeAsnDocument: TypeAsnDocument[] | undefined
  error: string | undefined
}

export const getTypeAsnDocumentAction = (
  typeAsnDocument?: TypeAsnDocument[],
  error?: string
): TypeAsnDocumentsAction => {
  return {
    type: GET_TYPE_ASN_DOCUMENT_EXITO,
    typeAsnDocument: typeAsnDocument,
    error
  }
}

// Esto va a SAGA
export interface TypeAsnDocumentsActionAsync {
  type: typeof GET_TYPE_ASN_DOCUMENT
}

export const getTypeAsnDocumentActionAsync =
  (): TypeAsnDocumentsActionAsync => {
    return {
      type: GET_TYPE_ASN_DOCUMENT
    }
  }
